// Gets the associated wishlist state for [session]
export const WishlistService_GetWishlistStateLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_GetWishlistState);
WishlistService_GetWishlistStateLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetWishlistState" as const;

// Adds a product to wishlist
export const WishlistService_AddProductLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_AddProduct);
WishlistService_AddProductLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/AddProduct" as const;

// Removes a product from wishlist
export const WishlistService_RemoveProductLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_RemoveProduct);
WishlistService_RemoveProductLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/RemoveProduct" as const;

// removes bulk products from the wishlist
export const WishlistService_RemoveProductBulkLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_RemoveProductBulk);
WishlistService_RemoveProductBulkLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/RemoveProductBulk" as const;

// Returns the content for the items tab
export const WishlistService_GetItemsTabContentLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_GetItemsTabContent);
WishlistService_GetItemsTabContentLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetItemsTabContent" as const;

// Returns the content for the brands tab
export const WishlistService_GetBrandsTabContentLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_GetBrandsTabContent);
WishlistService_GetBrandsTabContentLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetBrandsTabContent" as const;

// Returns the content stream for a single selected brand on the brands tab.
// Called for GetBrandsTabContent.active_brand and again on every carousel switch.
export const WishlistService_GetBrandTabStreamLazy = () =>
  import("./service.grpc").then((m) => m.WishlistService_GetBrandTabStream);
WishlistService_GetBrandTabStreamLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetBrandTabStream" as const;

// Returns the content for the owned items tab
export const WishlistService_GetOwnedItemsTabContentLazy = () =>
  import("./service.grpc").then(
    (m) => m.WishlistService_GetOwnedItemsTabContent
  );
WishlistService_GetOwnedItemsTabContentLazy.method =
  "aysa_api.services.wishlist.v1.WishlistService/GetOwnedItemsTabContent" as const;
